import { VaporPage } from "@vapor/react-custom";
import { WorkspaceSelector } from "@drift/oneplatfront-components/workspace-selector";

import { OneBoxPageDto } from "./OneBoxPageDto";

const OneBoxPage = ({ children, headerRight, showCustomerSelector, ...props }: OneBoxPageDto) => {
    return (
        <VaporPage
            {...props}
            headerRight={getHeaderRight(showCustomerSelector, headerRight)}
        >
            {children}
        </VaporPage>
    );
};

export default OneBoxPage;

const getHeaderRight = (
    showCustomerSelector = true,
    headerRight: React.ReactNode[] | React.ReactNode = [],
) => {
    const rightsElements = Array.isArray(headerRight) ? headerRight : [headerRight];

    if (showCustomerSelector) {
        rightsElements.push(<WorkspaceSelector />);
    }

    return rightsElements;
};
